import { Snackbar, Alert } from "@mui/material";
import styles from "./Snackbar.module.scss";

const SuccessSnackbar = ({ open, message, onClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity="success"
        variant="filled"
        className={`${styles.alert} ${styles.successAlert}`}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SuccessSnackbar;
